<template>
  <v-app>
    <v-main>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="btn-float"
            color="primary"
            dark
            absolute
            bottom
            right
            fab
            href="https://alaqeelah.sy/"
          >
            <v-icon>mdi-web</v-icon>
          </v-btn>
        </template>
        <span>الذهاب إلى موقع العقيلة </span>
      </v-tooltip>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>

<style scoped>
html,
body {
  overflow: clip !important;
}
.btn-float {
  position: absolute;
  bottom: 8vh !important;
  right: 2vw !important;
}
.row {
  margin: 0 !important;
}
</style>
